import React from 'react';
import { Modal } from 'react-bootstrap';
import CustomButton from '../CustomButton';
import './LogoutModal.css';
import { FaSignOutAlt } from 'react-icons/fa';

const LogoutModal = ({ show, onClose, onLogout, isLoading }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="logout-modal"
    >
      <Modal.Body className="text-center p-4">
        <div className="logout-icon mb-3 mt-5">
          <FaSignOutAlt />
        </div>
        <h4 className="mb-3">Logout</h4>
        <p className="text-muted mb-4">Are you sure you want to logout?</p>
        
        <div className="d-flex gap-3 justify-content-center">
          <CustomButton
            text="Cancel"
            onClick={onClose}
            variant="outline"
            className="px-4"
            disabled={isLoading}
          />
          <CustomButton
            text="Logout"
            onClick={onLogout}
            className="px-4"
            loading={isLoading}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
